new Vue({
    el: '#guests',
    data: function() {
        return {
            show_error: false,
            guest: {
                first_name: '',
                last_name: ''
            },
            guests: window.guests ? window.guests : []
        };
    },
    computed: {
        empty: function() {
            return (!this.guest.first_name || !this.guest.last_name);
        }
    },
    methods: {
        reset: function() {
            this.guest.first_name = '';
            this.guest.last_name = '';
        },
        add: function(event) {
            if (!this.empty) {
                this.show_error = false;
                this.guests.unshift({
                    "first_name": this.guest.first_name,
                    "last_name": this.guest.last_name,
                    "selections": {}
                });
                this.reset();
                return;
            }
            this.show_error = true;
        },
        remove: function(idx) {
            this.guests.splice(idx, 1);
        }
    }
});
